"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gates = gates;
exports.allGates = allGates;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _GatesUtils = require("lead-flows-ui/utils/GatesUtils");

var gatesToCheck = ['Leadin:KickbackEmailSending', 'Leadin:SequentialKickbackEmails', 'Leadin:Embedded', 'Leadin:LeadFlowTargetingOptions', 'Leadin:ConsciousCancel', 'Leadin:RedirectCalendarOption', 'LeadFlows:Scheduling', 'LeadFlows:AudienceTargeting', 'LeadFlows:TimeLine', 'Forms:PopupFormsDashboard', 'LeadFlows:DoiSettingsAccess', 'Forms:FormlessPopups', 'forms:configurableFromName'];
var INITIAL_STATE = {};

function gates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.SET_GATES:
      return Object.assign({}, state, (0, _GatesUtils.getGatesMap)(action.payload, gatesToCheck));

    default:
      return state;
  }
}

function allGates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.SET_GATES:
      return action.payload;

    default:
      return state;
  }
}